<!--suppress JSUnusedAssignment -->
<script lang="ts">
    import {moveSentenceToBeginning} from '$lib/utils/moveSentenceToBeginning';
    import SentenceMobile from '$lib/components/browse/WordCard/_Mobile/SentenceMobile.svelte';
    import type {UserWordsMapStore} from '$lib/classes/stores/get-user-words-map';
    import type {Sentence} from '$lib/classes/data/sentence';
    import type {UserWord} from '$lib/classes/data/user-word';
    import type {CurrentWord} from '$lib/stores/currentWord';
    import LastMarker from '$lib/components/browse/WordCard/Sentence/last-marker.svelte';

    export let currentWord: CurrentWord
    export let userWordsMap: UserWordsMapStore
    export let sentences: Sentence[]
    export let userWord: UserWord | undefined

    // MOVE savedSentence to beginning
    let savedSentenceId = userWord?.sentenceId

    if (savedSentenceId) {
        sentences = moveSentenceToBeginning(sentences, savedSentenceId)
    }

    let sentencesCount = sentences.length
    let section = 1
    let sectionCount = 30

    $: cutUntil = section * sectionCount < sentencesCount ? section * sectionCount : sentencesCount
    $: displaySentences = sentences.slice(0, cutUntil)

    function handleIntersecting() {
        section += 1
    }
</script>

<div id="sentences-mobile">
    {#each displaySentences as sentence}
        <SentenceMobile
                currentWord={currentWord}
                userWordsMap={userWordsMap}
                {sentence}
                {userWord}
        />
    {/each}

    <LastMarker onIntersecting={handleIntersecting}/>
</div>

<style>
    #sentences-mobile {
        padding-left: 1.1rem;
        padding-right: 38px;
        padding-bottom: 4rem;
    }
</style>